import { render, staticRenderFns } from "./PublishPanel.vue?vue&type=template&id=2c2d440c&scoped=true"
import script from "./PublishPanel.vue?vue&type=script&lang=js"
export * from "./PublishPanel.vue?vue&type=script&lang=js"
import style0 from "./PublishPanel.vue?vue&type=style&index=0&id=2c2d440c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2d440c",
  null
  
)

export default component.exports